import { render, staticRenderFns } from "./MyFav.vue?vue&type=template&id=6d9458bf&scoped=true"
import script from "./MyFav.vue?vue&type=script&lang=js"
export * from "./MyFav.vue?vue&type=script&lang=js"
import style0 from "./MyFav.vue?vue&type=style&index=0&id=6d9458bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9458bf",
  null
  
)

export default component.exports